function Position(x, y, z = 0) {

    this.name = 'position';

    this.x = x;
    this.y = y;
    this.z = z;
}

export {Position};
